import { Injectable } from '@angular/core';
import { SystemParametersDto, UpdateSystemParametersPayload } from '@nebula-shared/domain';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../crud/base-crud.service';

@Injectable({ providedIn: 'root' })
export class ServiceSystemParametersDate extends BaseCrudService<
  SystemParametersDto,
  Partial<SystemParametersDto>,
  UpdateSystemParametersPayload
> {
  constructor() {
    super();
    this.setBaseUrl('/nebula-accounting-core/api/v1/parametros-sistema');
  }

  getParametros(): Observable<SystemParametersDto> {
    return this.getSingle();
  }
}
